// import media files
import PortfolioItem1 from 'assets/images/portfolio/portfolio-large-1.jpg';
import PortfolioItem2 from 'assets/images/portfolio/portfolio-square-1.jpg';
import PortfolioItem3 from 'assets/images/portfolio/portfolio-large-2.jpg';
import PortfolioItem4 from 'assets/images/portfolio/portfolio-square-2.jpg';
import PortfolioItem5 from 'assets/images/portfolio/portfolio-large-3.jpg';
import PortfolioItem6 from 'assets/images/portfolio/portfolio-square-3.jpg';

export const PortfolioData = [
	{
		id: 1,
		image: PortfolioItem1,
		category: 'Website / Illustration / Art Direction',
		title: 'Makeup Mockup',
		link: '/marketing/portfolio/single/'
	},
	{
		id: 2,
		image: PortfolioItem2,
		category: 'Website / UX/UI / Development',
		title: 'Business Card',
		link: '/marketing/portfolio/single/'
	},
	{
		id: 3,
		image: PortfolioItem3,
		category: 'Website / Illustration / Art Direction',
		title: 'Makeup Mockup',
		link: '/marketing/portfolio/single/'
	},
	{
		id: 4,
		image: PortfolioItem4,
		category: 'Website / UX/UI / Development',
		title: 'Hello Summer',
		link: '/marketing/portfolio/single/'
	},
	{
		id: 5,
		image: PortfolioItem5,
		category: 'Mobile App / Development',
		title: 'Bottle Mockup',
		link: '/marketing/portfolio/single/'
	},
	{
		id: 6,
		image: PortfolioItem6,
		category: 'Website / UX/UI / Development',
		title: 'Jar Mockup',
		link: '/marketing/portfolio/single/'
	},
	{
		id: 7,
		image: PortfolioItem4,
		category: 'Website / UX/UI / Development',
		title: 'Hello Summer',
		link: '/marketing/portfolio/single/'
	},
	{
		id: 8,
		image: PortfolioItem5,
		category: 'Mobile App / Development',
		title: 'Bottle Mockup',
		link: '/marketing/portfolio/single/'
	},
	{
		id: 9,
		image: PortfolioItem6,
		category: 'Website / UX/UI / Development',
		title: 'Jar Mockup',
		link: '/marketing/portfolio/single/'
	}
];

export default PortfolioData;
